import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" eyebrow="PRIVACY" lastUpdated="January 2026">
      <p>
        This Privacy Policy explains how <strong>Tapped In Clarity</strong> ("we",
        "us", "our") — a sole trader business based in the United Kingdom and
        operator of <em>Albetheine&apos;s Oracle</em> mobile app, online guidebook
        and psychic medium readings — collects, uses and protects your personal
        information. Our business address is available on written request to{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>

      <h2>1. Who We Are</h2>
      <p>
        Tapped In Clarity is operated as a sole trader in the United Kingdom.
        For the purposes of UK GDPR and the Data Protection Act 2018, we are the
        data controller of any personal information you provide to us.
      </p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li>
          <strong>Account information:</strong> name, email address, and
          password when you create an account in the Albetheine Oracle app.
        </li>
        <li>
          <strong>Order information:</strong> billing name, billing address,
          email, and (when physical decks launch) shipping address.
        </li>
        <li>
          <strong>Payment information:</strong> processed directly by our
          third-party payment provider (Stripe). We do not store full card
          numbers on our servers.
        </li>
        <li>
          <strong>Reading enquiries:</strong> any information you choose to
          share by email when booking a psychic medium session.
        </li>
        <li>
          <strong>Usage data:</strong> basic technical information (device type,
          app version, anonymised analytics) used to keep the service running.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To provide and operate the Albetheine Oracle app, guidebook and readings.</li>
        <li>To process payments and deliver any items or digital goods you purchase.</li>
        <li>To respond to your enquiries and provide customer support.</li>
        <li>To send service-related emails (e.g. receipts, password resets).</li>
        <li>To comply with our legal obligations.</li>
      </ul>

      <h2>4. Lawful Basis</h2>
      <p>
        We process your data on the lawful bases of (a) performance of a
        contract with you, (b) your consent (which you can withdraw at any
        time), (c) our legitimate interests in running and protecting our
        business, and (d) compliance with legal obligations.
      </p>

      <h2>5. Sharing Your Information</h2>
      <p>
        We do not sell your personal information. We share only what is
        necessary with trusted providers who help us operate the service:
      </p>
      <ul>
        <li><strong>Stripe</strong> — payment processing.</li>
        <li><strong>Email & hosting providers</strong> — to deliver emails and host the service.</li>
        <li><strong>Print-on-demand fulfilment partner</strong> — for physical decks, once available.</li>
        <li><strong>Authorities</strong> — where legally required.</li>
      </ul>

      <h2>6. International Transfers</h2>
      <p>
        Some of our providers may process data outside the UK. Where they do,
        we rely on appropriate safeguards such as the UK International Data
        Transfer Agreement or the EU Standard Contractual Clauses.
      </p>

      <h2>7. How Long We Keep Your Data</h2>
      <p>
        We keep your personal information only for as long as needed to provide
        the service, to meet our legal and tax obligations, and to resolve
        disputes. Account data is deleted within a reasonable period after you
        request account closure.
      </p>

      <h2>8. Your Rights</h2>
      <p>Under UK GDPR you have the right to:</p>
      <ul>
        <li>Request a copy of the personal information we hold about you.</li>
        <li>Ask us to correct inaccurate information.</li>
        <li>Ask us to erase your information (subject to legal limits).</li>
        <li>Object to or restrict certain processing.</li>
        <li>Withdraw consent at any time.</li>
        <li>Complain to the Information Commissioner's Office (<a href="https://ico.org.uk" target="_blank" rel="noreferrer">ico.org.uk</a>).</li>
      </ul>

      <h2>9. Cookies</h2>
      <p>
        Our website uses only essential cookies and minimal anonymous analytics
        to keep the site working. We do not use cookies for advertising.
      </p>

      <h2>10. Children</h2>
      <p>
        Our services are intended for users aged 18 and over. We do not
        knowingly collect data from anyone under 18.
      </p>

      <h2>11. Contact</h2>
      <p>
        For any privacy question, or to exercise your rights, email{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
